// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Fechamentos_IndexResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for fechamentos listing endpoint
 *
 * GET /fechamentos
 *
 * Returns paginated list of fechamentos with summary data
 */
import type { Fechamentos_IndexItemRow } from './Fechamentos_IndexItemRow'
import type { Fechamentos_PaginationRow } from './Fechamentos_PaginationRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Fechamentos_IndexResponseDados {
items: Fechamentos_IndexItemRow[]
pagination: Fechamentos_PaginationRow
}

export type Fechamentos_IndexResponse = ApiResponse<Fechamentos_IndexResponseDados>;

registerResponseContract('Fechamentos_IndexResponse', {
  items: {
    type: 'array',
    required: true,
    items: {
      id:                             { type: 'number',  required: false },
      franquia_id:                    { type: 'number',  required: false },
      data_inicial:                   { type: 'string',  required: false },
      data_final:                     { type: 'string',  required: false },
      meta_faturamento:               { type: 'string',  required: false },
      meta_clientes:                  { type: 'number',  required: false },
      meta_itens:                     { type: 'number',  required: false },
      status:                         { type: 'string',  required: false },
      valor_realizado:                { type: 'string',  required: false },
      data_fechamento:                { type: 'string',  required: false },
      usuario_fechamento_id:          { type: 'string',  required: false },
      data_reabertura:                { type: 'string',  required: false },
      usuario_reabertura_id:          { type: 'string',  required: false },
      motivo_reabertura:              { type: 'string',  required: false },
      previsao_marketing:             { type: 'string',  required: false },
      previsao_insumos:               { type: 'string',  required: false },
      previsao_impostos:              { type: 'string',  required: false },
      previsao_taxas_cobranca:        { type: 'string',  required: false },
      total_previsto_folha_pagamento: { type: 'string',  required: false },
      numero_clientes:                { type: 'number',  required: false },
      itens_realizados:               { type: 'number',  required: false },
      faturamento_vendas_realizadas:  { type: 'string',  required: false },
      total_recebimentos_conferidos:  { type: 'string',  required: false },
      total_recebimentos_disponiveis: { type: 'string',  required: false },
      total_recebido_dinheiro:        { type: 'string',  required: false },
      total_despesas_pagas:           { type: 'string',  required: false },
      lucro_mensal:                   { type: 'string',  required: false },
      caixa_mensal:                   { type: 'string',  required: false },
      registro_mes_inauguracao:       { type: 'number',  required: false },
      conferido_pelo_franqueado:      { type: 'number',  required: false },
      created_at:                     { type: 'string',  required: false },
      updated_at:                     { type: 'string',  required: false },
      deleted_at:                     { type: 'string',  required: false },
      periodo_formatado:              { type: 'string',  required: false },
      resumo: {
        type: 'object',
        required: false,
        fields: {
          meta_faturamento:    { type: 'number',  required: true },
          meta_clientes:       { type: 'number',  required: false },
          total_previsto:      { type: 'number',  required: true },
          total_efetivo:       { type: 'number',  required: true },
          valor_realizado:     { type: 'number',  required: true },
          variacao_percentual: { type: 'number',  required: false },
          total_despesas:      { type: 'number',  required: true },
          lucro_liquido:       { type: 'number',  required: true },
          status:              { type: 'string',  required: true },
          periodo:             { type: 'string',  required: true },
        },
      },
    },
  },
  pagination: {
    type: 'object',
    required: true,
    fields: {
      total:       { type: 'number',  required: true },
      page:        { type: 'number',  required: true },
      per_page:    { type: 'number',  required: true },
      total_pages: { type: 'number',  required: true },
    },
  },
})
